import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ClassGroupMiaaPointsCard @event={{@model}}/>",{ moduleName: "bullitt-time-results/templates/event/miaa/points.hbs" })